import script from "./RightArrowIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./RightArrowIcon.vue?vue&type=script&setup=true&lang=js"

import "./RightArrowIcon.vue?vue&type=style&index=0&id=01625046&scoped=true&lang=css"
script.__scopeId = "data-v-01625046"

export default script